export const platformTranslations = {
  ru: {
    'platform.organizations.title': 'Организации',
    'platform.organizations.subtitle': 'Реестр клиентских организаций: настройки, Syrve-подключения и пользователи — из карточки организации',
    'platform.organizations.loading': 'Загружаем организации…',
    'platform.organizations.loadError': 'Не удалось загрузить организации.',
    'platform.organizations.list.empty.title': 'Нет организаций',
    'platform.organizations.list.empty.description': 'Создайте первую организацию для подключения Syrve и настройки квот.',
    'platform.organizations.column.organization': 'Организация',
    'platform.organizations.column.status': 'Статус',
    'platform.organizations.column.actions': 'Действия',
    'platform.organizations.column.lifecycle': 'Жизненный цикл',
    'platform.organizations.search.placeholder': 'Поиск по названию, ИНН или статусу…',
    'platform.organizations.search.aria': 'Поиск организаций',
    'platform.organizations.search.empty.title': 'Ничего не найдено',
    'platform.organizations.search.empty.description': 'Измените запрос или очистите поле поиска.',
    'platform.organizations.status.active': 'Активна',
    'platform.organizations.status.inactive': 'Неактивна',
    'platform.organizations.status.unknown': 'Неизвестно',
    'platform.organizations.action.open': 'Открыть',
    'platform.organizations.action.openSettings': 'Настройки',
    'platform.organizations.action.connections': 'Syrve',
    'platform.organizations.action.users': 'Пользователи',
    'platform.organizations.create.button': 'Создать организацию',
    'platform.organizations.create.title': 'Новая организация',
    'platform.organizations.create.name': 'Название',
    'platform.organizations.create.submit': 'Создать',
    'platform.organizations.create.success': 'Организация создана.',
    'platform.organizations.create.error': 'Не удалось создать организацию.',
    'platform.organizations.edit.button': 'Изменить',
    'platform.organizations.edit.title': 'Редактирование организации',
    'platform.organizations.edit.name': 'Название',
    'platform.organizations.edit.legalName': 'Юридическое название',
    'platform.organizations.edit.taxId': 'ИНН / Tax ID',
    'platform.organizations.edit.status': 'Статус',
    'platform.organizations.edit.submit': 'Сохранить',
    'platform.organizations.edit.success': 'Организация обновлена.',
    'platform.organizations.edit.error': 'Не удалось обновить организацию.',
    'platform.organizations.status.suspended': 'Приостановлена',
    'platform.organizations.status.archived': 'В архиве',
    'platform.organizations.archive.button': 'Архивировать',
    'platform.organizations.archive.title': 'Архивировать организацию?',
    'platform.organizations.archive.description': 'Организация «{name}» будет переведена в архив. Её можно восстановить, изменив статус на «Активна».',
    'platform.organizations.archive.confirm': 'Архивировать',
    'platform.organizations.archive.success': 'Организация архивирована.',
    'platform.organizations.archive.error': 'Не удалось архивировать организацию.',
    'platform.organizations.delete.button': 'Удалить',
    'platform.organizations.delete.title': 'Удалить организацию безвозвратно?',
    'platform.organizations.delete.description': 'Организация «{name}» и её outlets будут удалены из Pay. Операция необратима и доступна только для архивных организаций без операционных данных.',
    'platform.organizations.delete.reason': 'Причина удаления',
    'platform.organizations.delete.confirmName': 'Введите название организации для подтверждения',
    'platform.organizations.delete.confirm': 'Удалить безвозвратно',
    'platform.organizations.delete.success': 'Организация удалена.',
    'platform.organizations.delete.error': 'Не удалось удалить организацию.',
    'platform.users.title': 'Пользователи',
    'platform.users.subtitle': 'Учётные записи и назначения ролей на platform / organization / outlet scope',
    'platform.users.loading': 'Загружаем пользователей платформы…',
    'platform.users.loadError': 'Не удалось загрузить пользователей платформы.',
    'platform.users.create.title': 'Создать пользователя',
    'platform.users.create.email': 'Email',
    'platform.users.create.displayName': 'Имя',
    'platform.users.create.password': 'Пароль',
    'platform.users.detail.newPassword': 'Новый пароль',
    'platform.users.detail.newPasswordHint': 'Оставьте пустым, если пароль менять не нужно.',
    'platform.users.create.active': 'Активен',
    'platform.users.create.submit': 'Создать',
    'platform.users.create.success': 'Пользователь создан.',
    'platform.users.create.error': 'Не удалось создать пользователя.',
    'platform.users.createLink': 'Создать пользователя',
    'platform.users.list.title': 'Пользователи',
    'platform.users.list.empty.title': 'Нет пользователей',
    'platform.users.list.empty.description': 'Платформенные пользователи пока не созданы.',
    'platform.users.column.user': 'Пользователь',
    'platform.users.column.status': 'Статус',
    'platform.users.column.roles': 'Роли',
    'platform.users.column.created': 'Создан',
    'platform.users.column.assignments': 'Назначения',
    'platform.users.column.actions': 'Действия',
    'platform.users.status.active': 'Активен',
    'platform.users.status.inactive': 'Неактивен',
    'platform.users.action.edit': 'Изменить',
    'platform.users.openAssignments': 'Назначения',
    'platform.users.detail.createTitle': 'Новый пользователь',
    'platform.users.detail.createSubtitle': 'Создайте учётную запись и затем назначьте роли.',
    'platform.users.detail.editTitle': 'Пользователь: {name}',
    'platform.users.detail.back': 'К списку пользователей',
    'platform.users.detail.profileTitle': 'Профиль',
    'platform.users.detail.assignmentsTitle': 'Роли и доступ',
    'platform.users.detail.save': 'Сохранить',
    'platform.users.detail.saved': 'Изменения сохранены.',
    'platform.users.detail.saveError': 'Не удалось сохранить изменения.',
    'platform.users.detail.notFound': 'Пользователь не найден.',
    'platform.users.detail.deactivate': 'Деактивировать',
    'platform.users.detail.deactivateTitle': 'Деактивировать пользователя',
    'platform.users.detail.deactivateConfirm': 'Деактивировать пользователя {name}? Вход будет заблокирован, назначения ролей сохранятся.',
    'platform.users.detail.deactivated': 'Пользователь деактивирован.',
    'platform.users.detail.deactivateError': 'Не удалось деактивировать пользователя.',
    'platform.users.detail.scope.organization': 'Организация: {name}',
    'platform.users.detail.scope.location': 'Outlet: {name}',
    'platform.users.modal.title': 'Назначения: {name}',
    'platform.users.modal.role': 'Роль',
    'platform.users.modal.selectRole': 'Выберите роль',
    'platform.users.modal.organization': 'Организация',
    'platform.users.modal.platformScope': 'Platform scope',
    'platform.users.modal.outlet': 'Outlet',
    'platform.users.modal.organizationScope': 'Organization scope',
    'platform.users.modal.assign': 'Назначить',
    'platform.users.modal.empty.title': 'Нет назначений',
    'platform.users.modal.empty.description': 'Роли пока не назначены.',
    'platform.users.modal.empty.hint': 'Выберите роль и scope (platform, организация или outlet), затем нажмите «Назначить». Без роли пользователь не получит доступ.',
    'platform.users.modal.selectRoleRequired': 'Сначала выберите роль.',
    'platform.users.modal.rolesLoading': 'Загрузка списка ролей…',
    'platform.users.modal.rolesLoadError': 'Не удалось загрузить роли. Обновите страницу.',
    'platform.users.modal.noRolesAvailable': 'Нет доступных ролей для назначения.',
    'platform.users.modal.column.role': 'Роль',
    'platform.users.modal.column.scope': 'Scope',
    'platform.users.modal.column.actions': 'Действия',
    'platform.users.modal.scope.platform': 'Platform',
    'platform.users.modal.remove': 'Удалить',
    'platform.users.modal.roleAssigned': 'Роль назначена.',
    'platform.users.modal.assignmentRemoved': 'Назначение удалено.',
    'platform.users.modal.assignError': 'Не удалось назначить роль.',
    'platform.users.modal.removeError': 'Не удалось удалить назначение.',
  },
  en: {
    'platform.organizations.title': 'Platform Organizations',
    'platform.organizations.subtitle': 'MegaAdmin/MegaManager: organization registry and settings/quota context handoff',
    'platform.organizations.loading': 'Loading platform organizations…',
    'platform.organizations.loadError': 'Failed to load platform organizations.',
    'platform.organizations.list.empty.title': 'No organizations',
    'platform.organizations.list.empty.description': 'No platform organizations were found yet.',
    'platform.organizations.column.organization': 'Organization',
    'platform.organizations.column.status': 'Status',
    'platform.organizations.column.actions': 'Actions',
    'platform.organizations.column.lifecycle': 'Lifecycle',
    'platform.organizations.search.placeholder': 'Search by name, tax ID, or status…',
    'platform.organizations.search.aria': 'Search organizations',
    'platform.organizations.search.empty.title': 'No matches',
    'platform.organizations.search.empty.description': 'Try a different query or clear the search field.',
    'platform.organizations.status.active': 'Active',
    'platform.organizations.status.inactive': 'Inactive',
    'platform.organizations.status.unknown': 'Unknown',
    'platform.organizations.action.open': 'Open',
    'platform.organizations.action.openSettings': 'Settings',
    'platform.organizations.action.connections': 'Syrve',
    'platform.organizations.action.users': 'Users',
    'platform.organizations.create.button': 'Create organization',
    'platform.organizations.create.title': 'New organization',
    'platform.organizations.create.name': 'Name',
    'platform.organizations.create.submit': 'Create',
    'platform.organizations.create.success': 'Organization created.',
    'platform.organizations.create.error': 'Failed to create organization.',
    'platform.organizations.edit.button': 'Edit',
    'platform.organizations.edit.title': 'Edit organization',
    'platform.organizations.edit.name': 'Name',
    'platform.organizations.edit.legalName': 'Legal name',
    'platform.organizations.edit.taxId': 'Tax ID',
    'platform.organizations.edit.status': 'Status',
    'platform.organizations.edit.submit': 'Save',
    'platform.organizations.edit.success': 'Organization updated.',
    'platform.organizations.edit.error': 'Failed to update organization.',
    'platform.organizations.status.suspended': 'Suspended',
    'platform.organizations.status.archived': 'Archived',
    'platform.organizations.archive.button': 'Archive',
    'platform.organizations.archive.title': 'Archive organization?',
    'platform.organizations.archive.description': 'Organization "{name}" will be archived. You can restore it by setting status to Active.',
    'platform.organizations.archive.confirm': 'Archive',
    'platform.organizations.archive.success': 'Organization archived.',
    'platform.organizations.archive.error': 'Failed to archive organization.',
    'platform.organizations.delete.button': 'Delete',
    'platform.organizations.delete.title': 'Permanently delete organization?',
    'platform.organizations.delete.description': 'Organization "{name}" and its outlets will be removed from Pay. This is irreversible and only allowed for archived organizations without operational data.',
    'platform.organizations.delete.reason': 'Delete reason',
    'platform.organizations.delete.confirmName': 'Type the organization name to confirm',
    'platform.organizations.delete.confirm': 'Delete permanently',
    'platform.organizations.delete.success': 'Organization deleted.',
    'platform.organizations.delete.error': 'Failed to delete organization.',
    'platform.users.title': 'Users',
    'platform.users.subtitle': 'MegaAdmin/MegaManager: users, direct role assignments, organization and Outlet access',
    'platform.users.loading': 'Loading platform users…',
    'platform.users.loadError': 'Failed to load platform users.',
    'platform.users.create.title': 'Create user',
    'platform.users.create.email': 'Email',
    'platform.users.create.displayName': 'Display name',
    'platform.users.create.password': 'Password',
    'platform.users.detail.newPassword': 'New password',
    'platform.users.detail.newPasswordHint': 'Leave blank to keep the current password.',
    'platform.users.create.active': 'Active',
    'platform.users.create.submit': 'Create',
    'platform.users.create.success': 'User created.',
    'platform.users.create.error': 'Failed to create user.',
    'platform.users.createLink': 'Create user',
    'platform.users.list.title': 'Users',
    'platform.users.list.empty.title': 'No users',
    'platform.users.list.empty.description': 'No platform users have been created yet.',
    'platform.users.column.user': 'User',
    'platform.users.column.status': 'Status',
    'platform.users.column.roles': 'Roles',
    'platform.users.column.created': 'Created',
    'platform.users.column.assignments': 'Assignments',
    'platform.users.column.actions': 'Actions',
    'platform.users.status.active': 'Active',
    'platform.users.status.inactive': 'Inactive',
    'platform.users.action.edit': 'Edit',
    'platform.users.openAssignments': 'Assignments',
    'platform.users.detail.createTitle': 'New user',
    'platform.users.detail.createSubtitle': 'Create an account, then assign roles.',
    'platform.users.detail.editTitle': 'User: {name}',
    'platform.users.detail.back': 'Back to users',
    'platform.users.detail.profileTitle': 'Profile',
    'platform.users.detail.assignmentsTitle': 'Roles and access',
    'platform.users.detail.save': 'Save',
    'platform.users.detail.saved': 'Changes saved.',
    'platform.users.detail.saveError': 'Failed to save changes.',
    'platform.users.detail.notFound': 'User not found.',
    'platform.users.detail.deactivate': 'Deactivate',
    'platform.users.detail.deactivateTitle': 'Deactivate user',
    'platform.users.detail.deactivateConfirm': 'Deactivate user {name}? Sign-in will be blocked; role assignments remain.',
    'platform.users.detail.deactivated': 'User deactivated.',
    'platform.users.detail.deactivateError': 'Failed to deactivate user.',
    'platform.users.detail.scope.organization': 'Organization: {name}',
    'platform.users.detail.scope.location': 'Outlet: {name}',
    'platform.users.modal.title': 'Assignments: {name}',
    'platform.users.modal.role': 'Role',
    'platform.users.modal.selectRole': 'Select role',
    'platform.users.modal.organization': 'Organization',
    'platform.users.modal.platformScope': 'Platform scope',
    'platform.users.modal.outlet': 'Outlet',
    'platform.users.modal.organizationScope': 'Organization scope',
    'platform.users.modal.assign': 'Assign',
    'platform.users.modal.empty.title': 'No assignments',
    'platform.users.modal.empty.description': 'No roles assigned yet.',
    'platform.users.modal.empty.hint': 'Select a role and scope (platform, organization, or outlet), then click Assign. Without a role the user has no access.',
    'platform.users.modal.selectRoleRequired': 'Select a role first.',
    'platform.users.modal.rolesLoading': 'Loading roles…',
    'platform.users.modal.rolesLoadError': 'Failed to load roles. Refresh the page.',
    'platform.users.modal.noRolesAvailable': 'No assignable roles are available.',
    'platform.users.modal.column.role': 'Role',
    'platform.users.modal.column.scope': 'Scope',
    'platform.users.modal.column.actions': 'Actions',
    'platform.users.modal.scope.platform': 'Platform',
    'platform.users.modal.remove': 'Remove',
    'platform.users.modal.roleAssigned': 'Role assigned.',
    'platform.users.modal.assignmentRemoved': 'Assignment removed.',
    'platform.users.modal.assignError': 'Failed to assign role.',
    'platform.users.modal.removeError': 'Failed to remove assignment.',
  },
  id: {
    'platform.organizations.title': 'Platform Organizations',
    'platform.organizations.subtitle': 'MegaAdmin/MegaManager: registry organisasi dan konteks ke pengaturan/kuota',
    'platform.organizations.loading': 'Memuat organisasi platform…',
    'platform.organizations.loadError': 'Gagal memuat organisasi platform.',
    'platform.organizations.list.empty.title': 'Tidak ada organisasi',
    'platform.organizations.list.empty.description': 'Organisasi platform belum ditemukan.',
    'platform.organizations.column.organization': 'Organisasi',
    'platform.organizations.column.status': 'Status',
    'platform.organizations.column.actions': 'Tindakan',
    'platform.organizations.status.active': 'Active',
    'platform.organizations.status.inactive': 'Inactive',
    'platform.organizations.status.unknown': 'Unknown',
    'platform.organizations.action.open': 'Open',
    'platform.organizations.action.openSettings': 'Buka pengaturan/kuota',
    'platform.users.title': 'Platform Users',
    'platform.users.subtitle': 'MegaAdmin/MegaManager: users, direct role assignments, organization and Outlet access',
    'platform.users.loading': 'Memuat pengguna platform…',
    'platform.users.loadError': 'Gagal memuat pengguna platform.',
    'platform.users.create.title': 'Buat pengguna',
    'platform.users.create.email': 'Email',
    'platform.users.create.displayName': 'Display name',
    'platform.users.create.password': 'Password',
    'platform.users.detail.newPassword': 'New password',
    'platform.users.detail.newPasswordHint': 'Leave blank to keep the current password.',
    'platform.users.create.active': 'Active',
    'platform.users.create.submit': 'Buat',
    'platform.users.create.success': 'Pengguna dibuat.',
    'platform.users.create.error': 'Gagal membuat pengguna.',
    'platform.users.createLink': 'Buat pengguna',
    'platform.users.list.title': 'Pengguna',
    'platform.users.list.empty.title': 'Tidak ada pengguna',
    'platform.users.list.empty.description': 'Pengguna platform belum dibuat.',
    'platform.users.column.user': 'Pengguna',
    'platform.users.column.status': 'Status',
    'platform.users.column.roles': 'Peran',
    'platform.users.column.created': 'Dibuat',
    'platform.users.column.assignments': 'Assignments',
    'platform.users.column.actions': 'Tindakan',
    'platform.users.status.active': 'Active',
    'platform.users.status.inactive': 'Inactive',
    'platform.users.action.edit': 'Edit',
    'platform.users.openAssignments': 'Penugasan',
    'platform.users.detail.createTitle': 'Pengguna baru',
    'platform.users.detail.createSubtitle': 'Buat akun, lalu tetapkan peran.',
    'platform.users.detail.editTitle': 'Pengguna: {name}',
    'platform.users.detail.back': 'Kembali ke daftar',
    'platform.users.detail.profileTitle': 'Profil',
    'platform.users.detail.assignmentsTitle': 'Peran dan akses',
    'platform.users.detail.save': 'Simpan',
    'platform.users.detail.saved': 'Perubahan disimpan.',
    'platform.users.detail.saveError': 'Gagal menyimpan perubahan.',
    'platform.users.detail.notFound': 'Pengguna tidak ditemukan.',
    'platform.users.detail.deactivate': 'Nonaktifkan',
    'platform.users.detail.deactivateTitle': 'Nonaktifkan pengguna',
    'platform.users.detail.deactivateConfirm': 'Nonaktifkan pengguna {name}? Login akan diblokir; penugasan peran tetap ada.',
    'platform.users.detail.deactivated': 'Pengguna dinonaktifkan.',
    'platform.users.detail.deactivateError': 'Gagal menonaktifkan pengguna.',
    'platform.users.detail.scope.organization': 'Organisasi: {name}',
    'platform.users.detail.scope.location': 'Outlet: {name}',
    'platform.users.modal.title': 'Penugasan: {name}',
    'platform.users.modal.role': 'Peran',
    'platform.users.modal.selectRole': 'Pilih peran',
    'platform.users.modal.organization': 'Organisasi',
    'platform.users.modal.platformScope': 'Platform scope',
    'platform.users.modal.outlet': 'Outlet',
    'platform.users.modal.organizationScope': 'Organization scope',
    'platform.users.modal.assign': 'Tetapkan',
    'platform.users.modal.empty.title': 'Tidak ada penugasan',
    'platform.users.modal.empty.description': 'Belum ada peran yang ditugaskan.',
    'platform.users.modal.empty.hint': 'Pilih peran dan scope (platform, organisasi, atau outlet), lalu klik Assign. Tanpa peran pengguna tidak memiliki akses.',
    'platform.users.modal.selectRoleRequired': 'Pilih peran terlebih dahulu.',
    'platform.users.modal.rolesLoading': 'Memuat daftar peran…',
    'platform.users.modal.rolesLoadError': 'Gagal memuat peran. Segarkan halaman.',
    'platform.users.modal.noRolesAvailable': 'Tidak ada peran yang dapat ditugaskan.',
    'platform.users.modal.column.role': 'Peran',
    'platform.users.modal.column.scope': 'Scope',
    'platform.users.modal.column.actions': 'Tindakan',
    'platform.users.modal.scope.platform': 'Platform',
    'platform.users.modal.remove': 'Hapus',
    'platform.users.modal.roleAssigned': 'Peran ditetapkan.',
    'platform.users.modal.assignmentRemoved': 'Penugasan dihapus.',
    'platform.users.modal.assignError': 'Gagal menetapkan peran.',
    'platform.users.modal.removeError': 'Gagal menghapus penugasan.',
  },
} as const;
